import React from 'react';
import { Card } from './card';
import { ReactComponent as CheckCircleIcon } from './../../../assets/icons/check-circle.svg';
import { ReactComponent as ErrorCircleIcon } from './../../../assets/icons/error-circle.svg';
import { LoadText } from '../load/loadText';
import { css } from '../../../services/css';

import styles from './isActiveCard.module.css';

export const IsActiveCard = ({active = true, loading = false}) => {
    return <Card className={css(styles.Card, active ? styles.Active : styles.Inactive)}>
        <div className={css(styles.Icon, 'icon text-color')}>
            {
                (loading) ?
                <LoadText dark={false} max={100} min={100} strength={2} height='100%' />
                :
                (active) ?
                <CheckCircleIcon />
                : <ErrorCircleIcon />
            }
            
        </div>
        {
            (loading) ?
            <LoadText dark={false} max={100} min={60} strength={2} />
            :
            (active) ?
            'Active template'
            : 'Inactive template'
        }
    </Card>;
}